import { mapState } from 'vuex';
import { redirectToAppWithError } from '@/utils/appLoginHelper';

// @vue/component
export default {
  name: 'Loading',
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      showTryAgain: false,
      tryAgainTimeout: null,
    };
  },
  created() {
    this.setupTryAgain(this.isLoading);
  },
  watch: {
    isLoading(newVal) {
      this.setupTryAgain(newVal);
    },
  },
  methods: {
    setupTryAgain(isLoading) {
      if (isLoading) {
        this.tryAgainTimeout = setTimeout(() => {
          this.showTryAgain = true;
        }, 8000);
      } else {
        clearTimeout(this.tryAgainTimeout);
      }
    },
    onCancel() {
      if (!this.inAppLogin) return false;
      return redirectToAppWithError(this.appInfo, 'access_denied', 'user cancelled the login process');
    },
  },
  computed: {
    ...mapState({
      appInfo: (state) => state.login.appInfo,
      inAppLogin: (state) => state.login.loginType === 'app',
    }),
  },
};



// WEBPACK FOOTER //
// ./src/components/widgets/Loading/Loading.js